import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import {
  UntypedFormGroup,
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser';
import {
  NavController,
  AlertController,
  LoadingController,
  Platform,
  ToastController,
  ModalController,
  NavParams,
} from '@ionic/angular';
import { sha256 } from 'js-sha256';
import * as moment from 'moment';
import { Subscriber, Observable } from 'rxjs';
import { RemoteResponse } from 'src/RemoteResponse';
import { EditProfilePage } from 'src/app/pages/edit-profile/edit-profile.page';

import { AuthenticationService } from 'src/authentication-service';

import { TranslationService } from 'src/i18n/translation-service';
import { JsonService } from 'src/json-util';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { Custom_RequestMethod } from 'src/providers/common-service';
import { PaymentService } from 'src/providers/payment-service/payment-service';
import { PlayerService } from 'src/providers/player-service/player-service';
import { PlayerHomeDataService, PlayerHomeActions } from 'src/redux/player-home';
import { RemoteHttpService } from 'src/remote-http';
import { SearchDiscountCompanyPage } from '../../player-voucher/search-discount-company/search-discount-company.page';
import { PricesDisplayPage } from '../../prices-display/prices-display.page';
import {
  Country,
  DiscountCompany,
  DiscountCompanyProgram,
  HandicapSystem,
  PaymentGatewayInfo,
  PlayerDiscountProgram,
  PlayerHomeInfo,
  PlayerInfo,
  UserAddress,
  UserAuthentication,
} from 'src/data/mygolf.data';
import { CustomSha1 } from 'src/custom/sha1';
import { adjustViewZIndex } from '../../../../../globals';
import * as globals from '../../../../../globals';
import { map } from 'rxjs/operators';
import { ContentType, RemoteRequest } from 'src/remote-request';
import { InAppBrowser, InAppBrowserEvent } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { UserListAddressPage } from 'src/app/pages/user-profile/user-list-address/user-list-address.page';
import { UserManageAddressPage } from 'src/app/pages/user-profile/user-manage-address/user-manage-address.page';
import { OptionsMenuComponent } from './options-menu/options-menu.component';
import { CommonPullupMenuComponent } from '../../common-pullup-menu/common-pullup-menu.component';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';

@Component({
  selector: 'app-handicap-membership-add',
  templateUrl: './handicap-membership-add.page.html',
  styleUrls: ['./handicap-membership-add.page.scss'],
})
export class HandicapMembershipAddPage implements OnInit {
  signupForm: UntypedFormGroup;
  handicapNo: number;
  firstName: AbstractControl;
  lastName: AbstractControl;
  handicap: AbstractControl;
  email: AbstractControl;
  password: AbstractControl;
  password2: AbstractControl;
  gender: AbstractControl;
  teeoff: AbstractControl;
  country: AbstractControl;
  nationality: AbstractControl;
  countryList: Array<Country>;
  selectedCountry: Country;
  location: any;
  promoCode: AbstractControl;

  phone: AbstractControl;

  geoLong: number;
  geoLat: number;
  geoEnc: any;
  stringGeo: string;
  geoName: string;

  handicapSystems: Array<HandicapSystem>;
  handicapSystem: any;
  dateOfBirth: AbstractControl;
  programApplication: boolean = true;
  hasPromoCode: boolean = false;
  application: any;
  nhsNumber: AbstractControl;
  address1: AbstractControl;
  address2: AbstractControl;
  city: AbstractControl;
  state: AbstractControl;
  postalCode: AbstractControl;
  options: InAppBrowserOptions = {
    location: 'yes', //Or 'no'
    hidden: 'no', //Or  'yes'
    clearcache: 'yes',
    clearsessioncache: 'yes',
    zoom: 'yes', //Android only ,shows browser zoom controls
    hardwareback: 'yes',
    mediaPlaybackRequiresUserAction: 'no',
    shouldPauseOnSuspend: 'no', //Android only
    closebuttoncaption: 'Close', //iOS only
    disallowoverscroll: 'no', //iOS only
    toolbar: 'yes', //iOS only
    enableViewportScale: 'no', //iOS only
    allowInlineMediaPlayback: 'no', //iOS only
    presentationstyle: 'pagesheet', //iOS only
    fullscreen: 'yes', //Windows only
  };

  player: PlayerInfo;
  userAddressData: Array<UserAddress>;
  defaultUserAddress: UserAddress;
  birthDate: string;
  player$: Observable<PlayerInfo>;
  public playerHomeInfo$: Observable<PlayerHomeInfo>;
  @Input() partnerProgram: PlayerDiscountProgram;
  sha1: CustomSha1;

  termsRulesAgreed: boolean = false;
  retryPayment: boolean = false;
  enablePaymentTimer: boolean = true;
  paymentFailed: boolean = false;
  paymentDateTime: any;
  paymentTimerDuration: number = 5; //in minutes
  selectPaymentMethod: string;
  paymentBackendURL: string;
  paymentRedirectURL: string;
  paymentInternalURL: string;
  paymentPageURL: string;
  pgDescription: string;
  paymentSignAlgo: string;
  ipay88Details: any;
  _url: string;

  inputApplication: any = {
    fullName: '',
    govtDocumentNumber: '',
    dateOfBirth: null,
    armyPoliceId: '',
  };

  @Input() fromPromo: boolean = false;
  // iab: any;
  constructor(
    private fb: UntypedFormBuilder,
    // private renderer: Renderer,
    private renderer: Renderer2,
    private translator: TranslationService,
    private http: RemoteHttpService,
    private auth: AuthenticationService,
    private nav: NavController,
    private alertCtl: AlertController,
    private loadingCtl: LoadingController,
    private platform: Platform,
    private toastCtl: ToastController,
    private playerService: PlayerService,
    // private geolocation: Geolocation,
    private flightService: ClubFlightService,
    private paymentService: PaymentService,
    private iab: InAppBrowser,
    private navParams: NavParams,
    private router: Router,
    private modalCtrl: ModalController,

    // private viewCtrl: ViewController,
    private playerHomeService: PlayerHomeDataService,
    private playerHomeActions: PlayerHomeActions,
    public requestMethod: Custom_RequestMethod,
    private mg2uUtil: mygolfUtils

    // private nativeGeocoder: NativeGeocoder
  ) {
    // super();
    // this.iab = InAppBrowser;

    this.application = navParams.get('application');
    this.fromPromo = navParams.get('fromPromo');
    if (!!this.fromPromo) {
      this.selectedDiscountCompany = navParams.get('selectedDiscountCompany');
      this.selectedDiscountProgram = navParams.get('selectedDiscountProgram');
    }
    this.signupForm = this.fb.group({
      firstName: new UntypedFormControl('', [
        <any>Validators.required,
        <any>Validators.maxLength(50),
      ]),
      lastName: new UntypedFormControl('', [<any>Validators.maxLength(50)]), //['', Validators.compose([Validators.maxLength(50)])],
      handicap: new UntypedFormControl('24', [
        <any>Validators.required,
        <any>Validators.maxLength(50),
      ]), //['', Validators.compose([Validators.required])],
      email: new UntypedFormControl('', [<any>Validators.required, <any>Validators.maxLength(50)]),
      password: new UntypedFormControl('', [
        <any>Validators.required,
        <any>Validators.minLength(6),
        <any>Validators.maxLength(50),
      ]),
      password2: new UntypedFormControl('', [
        <any>Validators.required,
        <any>Validators.minLength(6),
        <any>Validators.maxLength(50),
      ]),
      phone: new UntypedFormControl(null, [
        <any>Validators.required,
        <any>Validators.minLength(10),
        <any>Validators.maxLength(50),
      ]),
      gender: new UntypedFormControl('M'),
      teeoff: new UntypedFormControl('Blue'),
      country: new UntypedFormControl('MYS'),
      nationality: new UntypedFormControl('MYS'),
      handicapSystem: new UntypedFormControl(''),
      promoCode: new UntypedFormControl('', [<any>Validators.minLength(3)]),
      dateOfBirth: new UntypedFormControl(''),
    });

    this.player = navParams.get('player');
    this.player$ = navParams.get('player$');
    this.partnerProgram = navParams.get('partnerProgram');

    let _param = this.platform.getQueryParam('programApplication');
    if ((_param && _param === 'true') || this.programApplication) {
      this.programApplication = true;
      this.signupForm = this.fb.group({
        firstName: new UntypedFormControl('', [
          <any>Validators.required,
          <any>Validators.maxLength(50),
        ]),
        lastName: new UntypedFormControl('', [<any>Validators.maxLength(50)]), //['', Validators.compose([Validators.maxLength(50)])],
        // handicap : new FormControl('24', [<any>Validators.required, <any>Validators.maxLength(50)]),//['', Validators.compose([Validators.required])],
        email: new UntypedFormControl('', [
          <any>Validators.required,
          <any>Validators.maxLength(50),
        ]),
        // password : new FormControl('', [<any>Validators.required, <any>Validators.minLength(6), <any>Validators.maxLength(50)]),
        // password2: new FormControl('', [<any>Validators.required, <any>Validators.minLength(6), <any>Validators.maxLength(50)]),
        phone: new UntypedFormControl(null, [
          <any>Validators.required,
          <any>Validators.minLength(10),
          <any>Validators.maxLength(50),
        ]),
        gender: new UntypedFormControl('M'),
        teeoff: new UntypedFormControl('Blue'),
        country: new UntypedFormControl('MYS'),
        nationality: new UntypedFormControl('MYS'),
        handicapSystem: new UntypedFormControl(''),
        promoCode: new UntypedFormControl(''), //[<any>Validators.minLength(3)]
        dateOfBirth: new UntypedFormControl(''), //[<any>Validators.required]
        partner_id: new UntypedFormControl(''),
        program_id: new UntypedFormControl(''),
        nhsNumber: new UntypedFormControl(''),
        address1: new UntypedFormControl(''),
        address2: new UntypedFormControl(''),
        city: new UntypedFormControl(''),
        state: new UntypedFormControl(''),
        postalCode: new UntypedFormControl(''),
      });
      this.userAddressData = [];
      if (this.player) {
        this.userAddressData = this.player.userAddresses;
        let _defaultAddress;
        if (this.userAddressData)
          _defaultAddress = this.userAddressData
            .filter((uad: UserAddress, idx, arr) => {
              if (arr && arr.length === 1 && !uad.defaultAddress) return true;
              else return uad.defaultAddress;
            })
            .map(uad => {
              this.defaultUserAddress = uad;
            });
      }

      this.firstName = this.signupForm.controls['firstName'];
      this.lastName = this.signupForm.controls['lastName'];
      this.handicap = this.signupForm.controls['handicap'];
      this.email = this.signupForm.controls['email'];
      this.password = this.signupForm.controls['password'];
      this.password2 = this.signupForm.controls['password2'];
      this.gender = this.signupForm.controls['gender'];
      this.teeoff = this.signupForm.controls['teeoff'];
      this.country = this.signupForm.controls['country'];
      this.nationality = this.signupForm.controls['nationality'];
      this.handicapSystem = this.signupForm.controls['handicapSystem'];
      this.phone = this.signupForm.controls['phone'];
      this.promoCode = this.signupForm.controls['promoCode'];
      this.dateOfBirth = this.signupForm.controls['dateOfBirth'];
      this.nhsNumber = this.signupForm.controls['nhsNumber'];
      this.address1 = this.signupForm.controls['address1'];
      this.address2 = this.signupForm.controls['address2'];
      this.city = this.signupForm.controls['city'];
      this.state = this.signupForm.controls['state'];
      this.postalCode = this.signupForm.controls['postalCode'];

      setTimeout(() => {
        if (this.player) {
          this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
          this.player$ = this.playerHomeInfo$.pipe(
            map((playerHomeInfo: PlayerHomeInfo) => playerHomeInfo.player)
          );

          console.debug('date of birth : ', this.player, this.player.birthdate);
          if (this.player?.birthdate) {
            this.dateOfBirth.setValue(this.player.birthdate);
          }
          this.nhsNumber.setValue(this.player.nhsNumber);
          this.firstName.setValue(this.player.firstName);
          this.lastName.setValue(this.player.lastName);
          this.email.setValue(this.player.email);
          this.phone.setValue(this.player.phone);
          this.gender.setValue(this.player.gender);
          this.teeoff.setValue(this.player.teeOffFrom);
          this.country.setValue(this.player.countryId);
          this.nationality.setValue(this.player.nationalityId);
          this.birthDate = moment(this.player.birthdate, 'YYYY-MM-DD').format('YYYY-MM-DD');
          this.userAddressData = this.player.userAddresses;
          let _defaultAddress;
          this.nhsNumber.setValue(this.player.nhsNumber);
          if (this.userAddressData && this.userAddressData.length > 0)
            _defaultAddress = this.userAddressData.filter((uad: UserAddress, idx, arr) => {
              if (arr && arr.length === 1 && !uad.defaultAddress) return true;
              else return uad.defaultAddress;
            });

          if (this.defaultUserAddress && this.defaultUserAddress.address) {
            this.address1.setValue(this.defaultUserAddress.address.address1);
            this.address2.setValue(this.defaultUserAddress.address.address2);
            this.city.setValue(this.defaultUserAddress.address.city);
            this.state.setValue(this.defaultUserAddress.address.state);
            this.postalCode.setValue(this.defaultUserAddress.address.postCode);
          }
        }

        if (this.application) {
          this.selectedDiscountCompany = this.application?.partnerProgram?.discountCompany;

          this.inputApplication = {
            fullName: this.application.fullName,
            govtDocumentNumber: this.application.govtDocumentNumber,
            armyPoliceId: this.application.armyPoliceId,
            dateOfBirth: moment(this.player.birthdate).format('YYYY-MM-DD'),
          };
          this.getDiscountPrograms(this.selectedDiscountCompany);
          setTimeout(() => {
            this.selectedDiscountProgram = this.application.partnerProgram.id;
          }, 500);
        } else if (this.partnerProgram) {
          this.selectedDiscountCompany = this.partnerProgram?.discountProgram?.discountCompany;

          this.getDiscountPrograms(this.selectedDiscountCompany);
          setTimeout(() => {
            this.selectedDiscountProgram = this.partnerProgram?.discountProgram?.id;
          }, 500);
        }
        this.retryPayment = navParams.get('retryPayment');
      }, 500);

      // this.getPaymentGateway();
    }
    if (!!this.fromPromo) {
      console.debug(
        'from promo : ',
        this.fromPromo,
        this.application,
        this.partnerProgram,
        this.selectedDiscountCompany,
        this.selectedDiscountProgram
      );
      // const partnerProgramId = this.selectedDiscountProgram;
      this.getDiscountPrograms(this.selectedDiscountCompany);
      // setTimeout(() => {
      //   this.selectedDiscountProgram = this.selectedDiscountProgram; // this.partnerProgram?.discountProgram?.id;
      // }, 500);
    }
    this.inputApplication = {
      fullName: '',
      govtDocumentNumber: '',
      armyPoliceId: '',
      dateOfBirth: null,
    };
  }
  ngOnInit(): void {
    this.onRefreshAddress();
    this.getPromoIsActive().then((result: any) => {
      if (result) {
        this.hasPromoCode = true;
      }
    });
  }

  ionViewDidLoad() {}

  selectCountry(countryName: string) {
    // this.clubInfo   = this.memberships.filter((membership: ClubMembership, idx: number) => {
    //     return membership.homeClub
    // }).map((membership: ClubMembership) => {
    //     return membership.club;
    // }).pop();

    this.selectedCountry = this.countryList
      .filter((c: Country) => {
        return c.name === countryName;
      })
      .pop();

    // this.country.id = this.selectedCountry.id
  }

  generateAddress(addressObj) {
    let obj = [];
    let address = '';
    for (let key in addressObj) {
      obj.push(addressObj[key]);

      //   if(key === 'countryName') this.geoName = addressObj[key]
    }
    obj.reverse();
    for (let val in obj) {
      if (obj[val].length) address += obj[val] + ', ';
    }
    return address.slice(0, -2);
  }

  ionViewDidEnter() {
    adjustViewZIndex(this.nav, this.renderer);
    this.getCountry();
    if (!this.programApplication) this.refreshHandicapSystem();
    this.onRefreshAddress();
  }

  onGenderChange(value) {
    // this.gender = value;
  }

  getCountry() {
    this.playerService.getCountryList().subscribe((data: Array<Country>) => {
      this.countryList = data;
    }),
      error => {
        // MessageDisplayUtil.showErrorToast(prResult.errorMessage, this.platform, this.toastCtl, 5000, "bottom");
      },
      complete => {};
  }

  async blockPayment() {
    // this.enablePaymentTimer = true;

    let _block: boolean = false;
    if (this.enablePaymentTimer) {
      if (this.paymentFailed && this.paymentDateTime) {
        let _currTime = moment();
        let _diffMinutes = _currTime.diff(this.paymentDateTime, 'minutes');

        if (_diffMinutes >= 0 && _diffMinutes < this.paymentTimerDuration) {
          // let alert = await this.alertCtl.create({
          //   header: 'Payment',
          //   // subTitle: 'Selected date is '+ _date,
          //   message: 'Your previous payment was not successful or in pending, please try again after ' + (this.paymentTimerDuration - _diffMinutes) + ' minute(s)', //'Selected date is ' + '<b>' + _date + '</b>',
          //   buttons: [{
          //     text: 'OK',
          //     handler: () => {
          //       // this.onRefreshClick();
          //       this.alertCtl.dismiss({
          //         needRefresh: true,
          //         paymentDateTime: this.paymentDateTime,
          //         paymentStatus: 'failed'
          //       })
          //     }
          //   }],

          // });
          // await alert.present();
          _block = true;

          this.showMessage(
            'Payment not successful',
            'Your previous payment was not successful or in pending, please try again after ' +
              (this.paymentTimerDuration - _diffMinutes) +
              ' minute(s)',
            true
          ).then((result: any) => {
            if (result) {
              this.modalCtrl.dismiss({
                needRefresh: true,
                paymentDateTime: this.paymentDateTime,
                paymentStatus: 'failed',
              });
            }
          });
        }
      }
    }
    return _block;
  }

  async onSubmit(value?: any) {
    if (!this.selectedDiscountCompany || !this.selectedDiscountProgram) {
      MessageDisplayUtil.showErrorToast(
        'Please select a Handicap Membership program',
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return false;
    }
    // if (await this.blockPayment()) return false;
    if (this.programApplication) {
      let loading = this.loadingCtl.create({
        showBackdrop: false,
        cssClass: 'nobg',
        message: 'Signing up...',
      });
      this.getPaymentGatewayPromise()
        .then((result: any) => {
          if (result && result.status === 'success') {
            this.onContinueApplication(value, loading);
          }
        })
        .catch(error => {});
      return;
    }

    //validate whether password1 and password 2 are same
    if (value.password !== value.password2) {
      let alert = await this.alertCtl.create({
        header: this.translator.translate('SignUpPage.password-mismatch-title'),
        message: this.translator.translate('SignUpPage.password-mismatch-message'),
        buttons: [this.translator.translate('SignUpPage.alert-ok')],
      });
      alert.present();
      return false;
    }

    if (!value.phone) {
      MessageDisplayUtil.showErrorToast(
        'Please enter valid Mobile numbers for better experience in the future',
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return false;
    }
    let _phoneLength = 10;
    // if(this.player.phone.startsWith('60')) _phoneLength = 11;
    if (!value.phone.startsWith('0')) _phoneLength = 11;
    // else
    if (value.phone && value.phone.length > 0 && value.phone.length < _phoneLength) {
      MessageDisplayUtil.showErrorToast(
        'Since Mobile number starts with ' +
          value.phone[0] +
          '. Please enter Mobile number more than ' +
          _phoneLength,
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      // + ' digits for better experience in the future',
      return false;
    }

    if (!value.handicap) {
      if (value.gender == 'M') {
        value.handicap = 24;
      } else {
        value.handicap = 36;
      }
    }

    // if(1) return;

    let loading = await this.loadingCtl.create({
      showBackdrop: false,
      cssClass: 'nobg',
      message: 'Signing up...',
    });
    let req = new RemoteRequest(
      globals.ServerUrls.registerPlayer,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      value
    );

    loading.present().then(() => {
      this.http.execute(req).subscribe(
        (resp: any) => {
          let prResult: PlayerInfo = resp;
          this.auth.setCurrenUser(prResult.email);

          // if(this.programApplication) {
          //     this.onContinueApplication(loading);
          // } else {
          loading.dismiss().then(async () => {
            let alert = await this.alertCtl.create({
              header: 'Registration!',
              message:
                'You registration was successfull.<br>Please login with your email and password',
              buttons: [
                {
                  text: 'OK',
                  handler: () => {
                    alert.dismiss().then(() => {
                      //  this.nav.setRoot(SignIn);
                    });
                    return false;
                  },
                },
              ],
            });
            alert.present();
          });
          // }
        },
        (error: any) => {
          let prResult = error;
          loading.dismiss().then(() => {
            if (prResult.errorMessage) {
              MessageDisplayUtil.showErrorToast(
                prResult.errorMessage,
                this.platform,
                this.toastCtl,
                5000,
                'bottom'
              );
            }
          });
        }
      );
    });
  }

  refreshHandicapSystem() {
    this.handicapSystems = [];
    this.flightService.getHandicapSystemList().subscribe((handicap: any) => {
      // Array<HandicapSystem>
      if (handicap && handicap.length > 0) {
        let _defHcpSystem;
        _defHcpSystem = handicap.filter(hcpSystem => {
          if (!this.handicapSystem || (this.handicapSystem && !this.handicapSystem.value)) {
            if (hcpSystem.defaultSystem) return true;
            // this.handicapSystem.value = hcpSystem.id;
          }
          // hcpSystem.
        });
        this.handicapSystems = handicap;
        let _defHcpSys;
        if (_defHcpSystem && _defHcpSystem.length > 0) _defHcpSys = _defHcpSystem[0].id;
        // this.signupForm.value.handicapSystem = _defHcpSystem[0].id;
        // this.fb.control({
        //     handicapSystem: _defHcpSystem[0].id
        // })
        // this.handicapSystem = _defHcpSystem[0].id;

        // this.signupForm = this.fb.group({
        //     handicapSystem : _defHcpSystem[0].id,
        // });

        this.signupForm = this.fb.group({
          firstName: new UntypedFormControl('', [
            <any>Validators.required,
            <any>Validators.maxLength(50),
          ]),
          lastName: new UntypedFormControl('', [<any>Validators.maxLength(50)]), //['', Validators.compose([Validators.maxLength(50)])],
          handicap: new UntypedFormControl('24', [
            <any>Validators.required,
            <any>Validators.maxLength(50),
          ]), //['', Validators.compose([Validators.required])],
          email: new UntypedFormControl('', [
            <any>Validators.required,
            <any>Validators.maxLength(50),
          ]),
          password: new UntypedFormControl('', [
            <any>Validators.required,
            <any>Validators.minLength(6),
            <any>Validators.maxLength(50),
          ]),
          password2: new UntypedFormControl('', [
            <any>Validators.required,
            <any>Validators.minLength(6),
            <any>Validators.maxLength(50),
          ]),
          phone: new UntypedFormControl(null, [
            <any>Validators.required,
            <any>Validators.minLength(10),
            <any>Validators.maxLength(50),
          ]),
          gender: new UntypedFormControl('M'),
          teeoff: new UntypedFormControl('Blue'),
          country: new UntypedFormControl('MYS'),
          nationality: new UntypedFormControl('MYS'),
          handicapSystem: new UntypedFormControl(_defHcpSys),
          promoCode: new UntypedFormControl('', [<any>Validators.minLength(3)]),
          dateOfBirth: new UntypedFormControl(''),
        });
        this.firstName = this.signupForm.controls['firstName'];
        this.lastName = this.signupForm.controls['lastName'];
        this.handicap = this.signupForm.controls['handicap'];
        this.email = this.signupForm.controls['email'];
        this.password = this.signupForm.controls['password'];
        this.password2 = this.signupForm.controls['password2'];
        this.gender = this.signupForm.controls['gender'];
        this.teeoff = this.signupForm.controls['teeoff'];
        this.country = this.signupForm.controls['country'];
        this.nationality = this.signupForm.controls['nationality'];
        this.handicapSystem = this.signupForm.controls['handicapSystem'];
        this.phone = this.signupForm.controls['phone'];
        this.promoCode = this.signupForm.controls['promoCode'];
        this.dateOfBirth = this.signupForm.controls['dateOfBirth'];
      }
    });
  }

  @Input() selectedDiscountCompany: DiscountCompany;
  discountPrograms: Array<DiscountCompanyProgram>;
  @Input() selectedDiscountProgram: any;
  paymentGatewayList: Array<PaymentGatewayInfo>;
  async onSearchDiscountCompany() {
    if (this.partnerProgram) return;
    if (this.hasPromoCode && this.promoValid) return;
    let _type = 'NGA_MEMBERSHIP';

    let modal = await this.modalCtrl.create({
      component: SearchDiscountCompanyPage,
      componentProps: {
        headerTitle: 'Select Company',
        partnerType: 'NGA_MEMBERSHIP',
        countryId: this.player?.countryId,
      },
    });
    modal.onDidDismiss().then((data: any) => {
      if (data.data && data.data.selected) {
        this.selectedDiscountProgram = null;
        this.selectedDiscountCompany = data.data.discCompany;

        this.getDiscountPrograms(this.selectedDiscountCompany);
        setTimeout(() => {
          if (
            (this.discountPrograms && this.discountPrograms.length === 0) ||
            !this.discountPrograms
          ) {
            MessageDisplayUtil.showMessageToast(
              'There is no program under this company. Please choose different company',
              this.platform,
              this.toastCtl,
              3000,
              'bottom'
            );
          }
          if (this.discountPrograms && this.discountPrograms.length === 1) {
            this.selectedDiscountProgram = this.discountPrograms[0].id;
          }
        }, 500);
      }
    });
    return await modal.present();
  }

  getDiscountCompanyName() {
    return this.selectedDiscountCompany && this.selectedDiscountCompany.name
      ? this.selectedDiscountCompany.name
      : 'Select Company (tap here)';
  }

  getDiscountPrograms(discountCompany: DiscountCompany) {
    if (!discountCompany) return false;
    let _companyId = discountCompany.id;
    this.flightService.getDiscountPrograms(_companyId).subscribe((data: any) => {
      if (data) {
        this.discountPrograms = data.filter((d: DiscountCompanyProgram) => {
          return d.includesHandicap;
        });
      }
    });
  }

  _setDefaultAddress(userId, addressData) {
    let _userId = userId;
    let data = addressData.name;
    this.flightService.userProfileSetDefaultAddress(_userId, data).subscribe(
      (data: any) => {
        if (data) {
          //   this.refreshProfile();
          MessageDisplayUtil.showMessageToast(
            'Successfully set ' + data.name + ' as default address',
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
        }
      },
      error => {
        MessageDisplayUtil.showErrorToast(
          'Failed to set ' + data + ' as default address',
          this.platform,
          this.toastCtl,
          3000,
          'bottom'
        );
      }
    );
  }
  async goEditAddressPage() {
    let _player;
    this.userAddressData = [];
    _player = JsonService.clone(this.player);
    this.userAddressData = _player.userAddresses; //JsonService.clone(_player.userAddresses);
    let modal = await this.modalCtrl.create({
      component: UserListAddressPage,
      componentProps: {
        userId: this.player.userId,
        player: this.player,
        userAddressData: this.userAddressData,
        fromProfile: false,
        callback: this.myCallbackFunction,
      },
    });
    modal.onDidDismiss().then(async (data: any) => {
      if (data && data.mode === 'setDefault') {
        if (data.addressData) {
          this._setDefaultAddress(this.player.userId, data.addressData);
        }
      } else if (data && data.mode === 'editAddress') {
        if (data.addressData) {
          let modal = await this.modalCtrl.create({
            component: UserManageAddressPage,
            componentProps: {
              mode: data.mode,
              userId: this.player.userId,
              player: this.player,
              userAddressData: data.addressData,
              fromProfile: false,
              callback: this.myCallbackFunction,
            },
          });

          modal.onDidDismiss().then((data: any) => {
            if (data) {
              if (data.mode === 'editAddress' && data.status === 'success') {
                if (this.userAddressData && this.userAddressData.length > 0)
                  this.userAddressData
                    .filter((uad, idx, arr) => {
                      if (arr && arr.length === 1 && !uad.defaultAddress) return true;
                      else return uad.defaultAddress;
                    })
                    .map(uad => {
                      uad = data.userAddressData;
                      this.defaultUserAddress = uad;
                    });
              }
            }
          });
          modal.present();
        }
      } else if (data && data.mode === 'newAddress') {
        let modal = await this.modalCtrl.create({
          component: UserManageAddressPage,
          componentProps: {
            mode: data.mode,
            userId: this.player.userId,
            player: this.player,
            userAddressData: data.addressData,
            fromProfile: false,
            callback: this.myCallbackFunction,
          },
        });
        modal.onDidDismiss().then(() => {
          // this.myCallbackFunction
        });
        modal.present();
      } else if (data && data.mode === 'deleteAddress') {
      }
    });
    await modal.present();
  }

  myCallbackFunction = function (_params) {
    return new Promise((resolve, reject) => {
      resolve(() => {
        this.onRefreshAddress();
        return {
          data: _params,
          status: 'success',
        };
      });
      if (!_params)
        reject({
          status: 'failed',
          data: _params,
        });
    });
  };

  async onUseDifferentAddress() {
    let _userAddressData = [];
    let _player;
    let _userId;
    this.userAddressData = [];
    _player = JsonService.clone(this.player);
    _userAddressData.push(..._player.userAddresses);
    this.userAddressData = [];
    this.userAddressData = JsonService.clone(_player.userAddresses);
    // this.player$.take(1)
    // .subscribe((player: PlayerInfo) => {
    //     _player = JsonService.clone(player);
    //     // this.userAddressData.push(..._player.userAddresses);
    // });
    let prompt: any = await this.alertCtl.create({
      header: 'Use Different address',
      buttons: [
        {
          text: 'Cancel',
          handler: async data => {
            prompt.dismiss().then(() => {
              if (this.platform.is('ios') && this.platform.is('capacitor')) {
                // this.keyboard.close();
              }
            });
            return false;
          },
        },
        {
          text: 'Change',
          handler: async data => {
            (await prompt).dismiss().then(() => {
              this.userAddressData
                .filter(uad => {
                  return uad.name === data;
                })
                .map(uad => {
                  this.defaultUserAddress = uad;
                  this.address1.setValue(this.defaultUserAddress.address.address1);
                  this.address2.setValue(this.defaultUserAddress.address.address2);
                  this.city.setValue(this.defaultUserAddress.address.city);
                  this.state.setValue(this.defaultUserAddress.address.state);
                  this.postalCode.setValue(this.defaultUserAddress.address.postCode);
                  this.nationality.setValue(this.defaultUserAddress.address.countryData.id);
                });
              // this.defaultUserAddress = data
              // this.flightService.userProfileSetDefaultAddress(_userId,data)
              // .subscribe((data)=>{
              //     if(data) {
              //         // this.refreshProfile();
              //         MessageDisplayUtil.showMessageToast('Successfully set '+data.name+' as default address',
              //         this.platform, this.toastCtl,3000, 'bottom');
              //     }
              // },(error)=>{
              //     MessageDisplayUtil.showErrorToast('Failed to set '+data+' as default address',
              //     this.platform, this.toastCtl,3000, 'bottom');

              // })
            });
            return false;
          },
        },
      ],
    });
    _userAddressData.forEach((uad: UserAddress) => {
      let _country = '';
      if (uad.address.countryData) _country = '(' + uad.address.countryData.id + ')';
      prompt.addInput({
        type: 'radio',
        label: uad.name + _country,
        value: uad.name,
        checked: uad.defaultAddress ? true : false,
      });
    });
    prompt.present();
  }

  getPaymentGatewayPromise() {
    return new Promise((resolve, reject) => {
      this.paymentService.getPaymentGateway(this.selectedDiscountCompany.country.id).subscribe(
        (pgList: Array<PaymentGatewayInfo>) => {
          if (pgList && pgList.length > 0) {
            this.paymentGatewayList = pgList;
            // this.selectPaymentMethod = this.paymentGatewayList[0].id
            resolve({
              status: 'success',
            });
          } else {
            reject({
              status: 'failed',
            });
          }
        },
        error => {
          reject({
            status: 'failed',
          });
        }
      );
    });
  }
  onContinueApplication(value: any, loader?: any) {
    let _needPayment: boolean = false;
    let _selectedDiscountProgram: DiscountCompanyProgram;
    if (!this.discountPrograms) return;
    if (!this.selectedDiscountProgram) return;
    this.discountPrograms
      .filter(d => {
        return d.id === this.selectedDiscountProgram;
      })
      .map(d => {
        if (d && d.discountAmount > 0) {
          _needPayment = true;
          _selectedDiscountProgram = d;
        }
      });
    if (_needPayment) {
      // this.getPaymentGateway(_selectedDiscountProgram.discountCompany.country.id)
      if (this.paymentGatewayList) {
        this.paymentGatewayList = this.paymentGatewayList.filter(pg => {
          return pg.country_id === _selectedDiscountProgram.discountCompany.country.id;
        });
      }
      this.onPayment(_selectedDiscountProgram, value);
    }
  }

  async onPayment(selDP: DiscountCompanyProgram, value: any) {
    let _countryId =
      selDP.discountCompany && selDP.discountCompany.country.id
        ? selDP.discountCompany.country.id
        : 'MYS';
    // let _amount = selDP.discountAmount;
    // let _userEmail = this.email;
    // let _userContact = this.phone;
    // let _userName = this.firstName + ' ' + this.lastName;
    let _currencyCode = selDP.discountCompany.country.currencyCode;
    let _url: string;

    let _mygolfServerHost = globals.MygolfServerHost;
    if (_mygolfServerHost)
      this.paymentBackendURL = 'http://' + _mygolfServerHost + '/rest/payment/ipay88/backend';
    let itemizedBill = await this.modalCtrl.create({
      component: PricesDisplayPage,
      componentProps: {
        headerName: 'Itemized Bill',
        // slot: this.bookingSlot,
        type: 'payment_application',
        // paymentAmountType: this.paymentAmountType,
        depositAmount: selDP.discountAmount,
        // itemBill: this.bookingItemBill,
        paymentGatewayList: this.paymentGatewayList,
        countryId: selDP.discountCompany.country.id,
        currencyCode: _currencyCode,
        // clubPayment: this.clubPayment,
        // voucherApplied: this.bookingDiscounts,
        // currentPlayer: this.currentPlayer,
        // bookingOptions: this.bookingOptions
      },
    });
    itemizedBill.onDidDismiss().then((data: any) => {
      if (data && !data.data.confirm) {
        MessageDisplayUtil.showErrorToast(
          'Please try again',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        return;
      }
      let _paymentDetails;
      this.selectPaymentMethod = data.data.selectPaymentMethod;

      let _paymentGateway = this.selectPaymentMethod.includes('ipay88') ? 'ipay88' : 'billplz';

      let _pgRegion;
      let _type;
      if (this.paymentGatewayList)
        this.paymentGatewayList
          .filter((pg: PaymentGatewayInfo) => {
            return pg.type === _paymentGateway && pg.id === this.selectPaymentMethod;
          })
          .map(pg => {
            console.debug('selected payment gateway : ', pg);
            _pgRegion = pg.id;
            _countryId = pg.country_id;
            _type = pg.type;
            this.ipay88Details = pg;
            this.ipay88Details.merchantCode = pg.merchant_code;
            this.ipay88Details.merchantKey = pg.merchant_key;
            //  = {
            //   merchantCode: pg.merchant_code,
            //   merchantKey: pg.merchant_key
            // }
            this.paymentBackendURL = pg.callback_url;
            this.paymentRedirectURL = pg.redirect_url;
            this.paymentInternalURL = pg.internal_payment_url;
            this.paymentPageURL = pg.http_server + pg.payment_url;
            this.pgDescription = pg.description;

            if (pg.signature_algorithm && pg.signature_algorithm.length > 0)
              this.paymentSignAlgo = pg.signature_algorithm;
            if (pg.signature_algorithm && pg.signature_algorithm.length > 0)
              this.paymentSignAlgo = this.paymentSignAlgo.replace('-', '');
            this._url = this.paymentInternalURL ? this.paymentInternalURL : pg.internal_payment_url;
          });

      if (this.retryPayment) {
        if (this.application) {
          let _params = this.application;
          if (this.inputApplication) {
            _params['fullName'] = this.inputApplication.fullName;
            _params['govtDocumentNumber'] = this.inputApplication.govtDocumentNumber;
            _params['armyPoliceId'] = this.inputApplication.armyPoliceId;
            _params['dateOfBirth'] = this.inputApplication.dateOfBirth;
          }
          let _partnerId = this.selectedDiscountCompany.id;
          let _programId = this.selectedDiscountProgram;
          this.flightService
            .updateProgramApplication(_partnerId, _programId, _params)
            .subscribe(updateData => {
              console.debug('successfully updated application : ', updateData);
              this.onSettingPayment(selDP, updateData);
            });
        }
      } else {
        this.onRegisteringApplication()
          .then((result: any) => {
            if (result && result.status === 'success') {
              this.onSettingPayment(selDP, result.data);
            } else return;
          })
          .catch(error => {
            let _error = error;
            let _msg = _error.errorMessage;
            // 'There was an issue registering applcation. Please try again later.'
            MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 5000, 'bottom');
          });
      }
    });
    itemizedBill.present();
  }

  async goEditProfilePage() {
    let modal = await this.modalCtrl.create({
      component: EditProfilePage,
      componentProps: {
        homeInfo: this.playerHomeInfo$,
        player: this.player$,
        type: 'playerProfile',
      },
    });
    modal.onDidDismiss().then((data?: any) => {});
    modal.present();
  }

  getDiscountProgramDetails(attribute?: string) {
    if (!this.selectedDiscountProgram) return;
    if (this.selectedDiscountProgram === '') return;
    if (!this.discountPrograms) return;
    if (this.discountPrograms && this.discountPrograms.length === 0) return;
    let _selDiscountProgram: DiscountCompanyProgram;
    if (this.discountPrograms && this.discountPrograms.length > 0) {
      this.discountPrograms
        .filter((dp: DiscountCompanyProgram) => {
          return dp.id === this.selectedDiscountProgram;
        })
        .map(dp => {
          _selDiscountProgram = dp;
        });
    }
    if (!_selDiscountProgram) return;
    switch (attribute) {
      case 'isInsurance':
        return _selDiscountProgram.includesInsurance;
      case 'isDiscount':
        return _selDiscountProgram.includesDiscount;
      case 'isHandicap':
        return _selDiscountProgram.includesHandicap;
      case 'startDate':
        return;
      case 'endDate':
        return;
      case 'validity':
        if (_selDiscountProgram && !_selDiscountProgram.validityMonths) return;
        if (_selDiscountProgram.validityMonths < 12)
          return _selDiscountProgram.validityMonths + ' months';
        else if (_selDiscountProgram.validityMonths >= 12) {
          let _years = 0;
          let _months = 0;
          _years = Math.floor(_selDiscountProgram.validityMonths / 12);
          _months = _selDiscountProgram.validityMonths % 12;
          let _txt = '';
          if (_years > 0 && _years === 1) _txt = _years + ' year';
          else if (_years > 1) _txt = _years + ' years';
          if (_months > 0 && _months === 1) _txt += _months + ' month';
          else if (_months > 1) _txt = _months + ' months';
          return _txt;
        }
      case 'insValidity':
        if (!_selDiscountProgram.includesInsurance) return;
        if (_selDiscountProgram && !_selDiscountProgram.insuranceValidityMonths) return;
        if (_selDiscountProgram.insuranceValidityMonths < 12)
          return _selDiscountProgram.insuranceValidityMonths + ' months';
        else if (_selDiscountProgram.insuranceValidityMonths >= 12) {
          let _years = 0;
          let _months = 0;
          _years = Math.floor(_selDiscountProgram.insuranceValidityMonths / 12);
          _months = _selDiscountProgram.insuranceValidityMonths % 12;
          let _txt = '';
          if (_years > 0 && _years === 1) _txt = _years + ' year';
          else if (_years > 1) _txt = _years + ' years';
          if (_months > 0 && _months === 1) _txt += _months + ' month';
          else if (_months > 1) _txt = _months + ' months';
          return _txt;
        }
      case 'amount':
        return (
          _selDiscountProgram.discountCompany.country.currencySymbol +
          ' ' +
          _selDiscountProgram.discountAmount
        );
      case 'progDesc':
        //                 MGA – This program only provides WHS handicap subscription.
        // GoGolf – This program provides WHS and personal Golfers insurance.
        // AGSSG – This program provides WHS, group insurance and preferred golfing rates at participating clubs.
        let _txt = [];
        if (_selDiscountProgram.description && _selDiscountProgram.description.length > 0)
          _txt.push(_selDiscountProgram.description);

        let _includes = [];
        if (_selDiscountProgram.includesDiscount)
          _includes.push('preferred golfing rates at participating clubs');
        if (_selDiscountProgram.includesInsurance) _includes.push('insurance');
        if (_selDiscountProgram.includesHandicap) _includes.push('WHS handicap subscription');
        if (_includes && _includes.length === 1) _txt.push('This program only provides ');
        else if (_includes && _includes.length > 1) _txt.push('This program provides ');

        return '* ' + _txt.join('<br>') + _includes.join(', ');
    }
  }

  onSettingPayment(selDP, application?) {
    // let _countryId = selDP.discountCompany && selDP.discountCompany.country.id?selDP.discountCompany.country.id:'MYS';
    let _player = this.player;
    let _playerId = this.player ? this.player.id | this.player.playerId : null;
    let _amount = selDP.discountAmount;
    let _userEmail = this.player.email; // this.email.value;
    let _userContact = this.player.phone; //this.phone.value;
    let _userName = this.player.playerName; // this.firstName.value + ' ' + this.lastName.value;
    let _currencyCode = selDP.discountCompany.country.currencyCode;
    let _paymentDetails;
    let _paymentGateway = 'ipay88';
    let _pgRegion;
    let _pgDescription;
    let _countryId;
    this.sandboxPayment = false;

    if (this.selectPaymentMethod === 'billplz') {
      _paymentDetails = {
        collection_id: 'q70lo0l_',
        amount: _amount * 100,
        email: _userEmail,
        name: _userName,
        mobile: _userContact,
        description: 'Payment for Handicap Application',
        currency: _currencyCode,
        callback_url: '', //this.paymentCallbackURL,// 'http://devlet.mygolf2u.com/rest/payment/billplz/callback',
        redirect_url: this.paymentRedirectURL, //'http://mtest.mygolf2u.com/test/payment_redirect.html',
        bill_type: 'nhs_application',
        bill_type_id: application.id, //application ID
        paid_by: _playerId, //if Player, playerId; if partner/club, userId?  this.fromClub?this.currSession.userId:this.currentPlayerId,
        payer_type: 'R', //if Player, 'R'; if partner/club, 'C'?
        payment_type: 'B', //this is Full Payment?
        payment_gateway: 'billplz',
      };
      _paymentGateway = 'billplz';
      if (_paymentDetails)
        this.onProcessPayment(
          _paymentDetails,
          _paymentGateway,
          _pgRegion,
          _countryId,
          _pgDescription
        );
    } else if (this.selectPaymentMethod.toLowerCase().includes('ipay88')) {
      _paymentGateway = 'ipay88';
      this.setPaymentAmountPromise(_paymentGateway, _amount)
        .then((result: any) => {
          if (result && result.status === 'success') {
            _amount = result.amount;
            _pgRegion = result.pgRegion;
            _countryId = result.countryId;
            _pgDescription = result.pgDescription;
            _paymentDetails = {
              collection_id: 'q70lo0l_',
              amount: result.amount,
              // "email": this.fromClub?this.bookingSlot.bookingPlayers[0].email:this.currentPlayer.email,//this.bookingSlot.bookedByPlayer.email,
              // "name": this.fromClub?this.bookingSlot.bookingPlayers[0].playerName:this.currentPlayer.playerName,//this.bookingSlot.bookedByPlayer.playerName,
              // "mobile": this.fromClub?this.bookingSlot.bookingPlayers[0].player.address.phone1:this.currentPlayer.addressInfo.phone1,//this.bookingSlot.bookedByPlayer.address.phone1 ? this.bookingSlot.bookedByPlayer.address.phone1 : this.bookingSlot.bookedByPlayer.address.phone2, //this.bookingSlot., no phone in bookedbyplayer!
              email: _userEmail,
              name: _userName,
              mobile: _userContact,
              description: 'NHS Handicap Application',
              currency: _currencyCode,
              callback_url: this.paymentBackendURL, //'http://devlet.mygolf2u.com/rest/payment/ipay88/backend',
              redirect_url: this.paymentRedirectURL,
              bill_type: 'nhs_application',
              bill_type_id: application.id, //application ID
              paid_by: _playerId,
              payer_type: 'R', //R-egistered, P-aid by one of the player, U-paid by someone else, C-lub user
              payment_type: 'B',
              payment_gateway: _pgRegion,
            };
            _paymentGateway = _paymentGateway;

            if (_paymentDetails)
              this.onProcessPayment(
                _paymentDetails,
                _paymentGateway,
                _pgRegion,
                _countryId,
                _pgDescription
              );
          }
        })
        .catch(error => {});
    }

    // if(1) return;
  }

  sandboxPayment: boolean = false;
  setPaymentAmountPromise(_paymentGateway, amount?: number) {
    return new Promise((resolve, reject) => {
      let _paymentDetails;
      // let _paymentGateway;
      let _pgRegion;
      let _countryId;
      let _type;
      let _url;
      let _amountPay = 0;
      // let sandboxPayment;
      let _amount; // = 0;
      if (amount) _amountPay = amount;
      let _pgDescription;
      if (this.paymentGatewayList)
        this.paymentGatewayList
          .filter((pg: PaymentGatewayInfo) => {
            return pg.type.toLowerCase() === _paymentGateway && pg.id === this.selectPaymentMethod;
            // && pg.id === _selPM

            // return pg.id.includes(_paymentGateway)
          })
          .map(pg => {
            _pgRegion = pg.id;
            _countryId = pg.country_id;
            _type = pg.type;
            // this.ipay88Details = {
            //     merchantCode: pg.merchant_code,
            //     merchantKey: pg.merchant_key
            // }
            this.paymentBackendURL = pg.callback_url;
            this.paymentRedirectURL = pg.redirect_url;
            this.paymentInternalURL = pg.internal_payment_url;
            this.paymentPageURL = pg.http_server + pg.payment_url;
            this.pgDescription = pg.description;
            _pgDescription = pg.description;

            if (pg.signature_algorithm && pg.signature_algorithm.length > 0)
              this.paymentSignAlgo = pg.signature_algorithm;
            if (pg.signature_algorithm && pg.signature_algorithm.length > 0)
              this.paymentSignAlgo = this.paymentSignAlgo.replace('-', '');
            this._url = this.paymentInternalURL ? this.paymentInternalURL : pg.internal_payment_url;
          });
      if (this.pgDescription.toLowerCase().includes('Sandbox'.toLowerCase())) _amountPay = 10000;
      if (this.selectPaymentMethod.toLowerCase().includes('ipay88')) {
        // let _amount = (_pgRegion.toLowerCase().includes('ipay88-id'))?_amountPay*100:1*100;

        if (
          _pgRegion.toLowerCase().includes('ipay88-id') &&
          !this.pgDescription.toLowerCase().includes('sandbox')
        )
          _amount = _amountPay * 100;
        else if (
          _pgRegion.toLowerCase().includes('ipay88-id') &&
          this.pgDescription.toLowerCase().includes('sandbox')
        )
          _amount = _amountPay;
        // else if(!_pgRegion.toLowerCase().includes('ipay88-id') && this.pgDescription.toLowerCase().includes('Sandbox'.toLowerCase())) _amount = 1;
        else if (
          _type.toLowerCase().includes('ipay88') &&
          _countryId.toLowerCase() === 'mys' &&
          !this.pgDescription.toLowerCase().includes('Sandbox'.toLowerCase())
        )
          _amount = _amountPay * 100;
        else if (
          _type.toLowerCase().includes('ipay88') &&
          _countryId.toLowerCase() === 'mys' &&
          this.pgDescription.toLowerCase().includes('Sandbox'.toLowerCase())
        ) {
          _amount = 100;
          this.sandboxPayment = true;
        } else _amount = _amountPay * 100;
      }
      if (_pgRegion) {
        resolve({
          status: 'success',
          amount: Number(_amount),
          pgRegion: _pgRegion,
          countryId: _countryId,
          pgDescription: _pgDescription,
        });
      } else if (!_pgRegion) {
        reject({
          status: 'failed',
        });
      }
    });
  }

  //     getPaymentGateway(countryId?: string,paymentGatewayId?: string) {
  //         let _paymentGateway;
  //         let _countryId = countryId?countryId:null;
  //         this.paymentService.getPaymentGateway(_countryId,_paymentGateway)
  //         .subscribe((pgList: Array<PaymentGatewayInfo>)=>{

  //             if(pgList && pgList.length > 0 ) this.paymentGatewayList = pgList;
  //             // if(this.paymentGatewayList && this.paymentGatewayList.length > 0) {
  //             //     this.paymentBackendURL = this.pay
  //             // }
  //         })
  //     }

  onRegisteringApplication(value?) {
    return new Promise(async (resolve, reject) => {
      let loading = await this.loadingCtl.create({
        showBackdrop: false,
        cssClass: 'nobg',
        message: 'Signing up...',
      });
      let _playerId = this.player.id | this.player.playerId;
      let _partnerId = this.selectedDiscountCompany.id;
      let _programId = this.selectedDiscountProgram;
      this.flightService.createProgramApplication(_partnerId, _programId, _playerId).subscribe(
        data => {
          if (data) {
            let _params = data;
            if (this.inputApplication) {
              _params['fullName'] = this.inputApplication.fullName;
              _params['govtDocumentNumber'] = this.inputApplication.govtDocumentNumber;
              _params['armyPoliceId'] = this.inputApplication.armyPoliceId;
              _params['dateOfBirth'] = this.inputApplication.dateOfBirth;
            }
            this.flightService
              .updateProgramApplication(_partnerId, _programId, _params)
              .subscribe(updateData => {
                console.debug('successfully updated application : ', updateData);
              });
          }
          resolve({
            status: 'success',
            data: data,
          });
        },
        error => {
          reject({
            status: 'failed',
            data: null,
            error: error,
          });
        }
      );
    });
  }

  onCheckExistingNHS() {}

  localBill: any;
  async onProcessPayment(
    paymentDetails,
    _paymentGateway,
    _pgRegion?,
    _countryId?,
    _pgDescription?
  ) {
    let _collectionId: string = 'q70lo0l_';
    let _signature = '';
    let loader = await this.loadingCtl.create({
      showBackdrop: false,
      cssClass: 'nobg',
      message: 'Processing payment...',
      duration: 10000,
    });
    loader.present().then(() => {
      this.paymentService.createBill(_collectionId, paymentDetails, _paymentGateway).subscribe(
        async (data: any) => {
          loader.dismiss().then(
            () => {
              // if(data) {
              // //   this.paidBillId = data.id
              // }
              if (data.url && this.selectPaymentMethod.toLowerCase().includes('billplz')) {
                // (data.url && this.selectPaymentMethod !== 'ipay88' && this.selectPaymentMethod !== 'ipay88page'
                // && this.selectPaymentMethod !== 'ipay88fpx') {
                if (this.platform.is('capacitor')) {
                  this.openWithInAppBrowser(data.url, null, 'getBill', data);

                  // MessageDisplayUtil.showMessageToast('cordova browser',
                  //     this.platform, this.toastCtl, 10000, "bottom")
                }
                // else if (this.platform.is('ios') || this.platform.is('iphone')) {
                //     this.openWithInAppBrowser(data.url,null,'getBill',data)

                //     // let win = window.open(data.url, '_system');
                //     // win.location.href = data.url;
                //     // let winTick = setInterval(()=> {
                //     //     if (win.closed) {
                //     //         clearInterval(winTick);
                //     //         this.getBill(data.id, 'billplz');

                //     //     }
                //     // }, 500);
                // }
                else {
                  // this.openWithCordovaBrowser(data.url);
                  let win = window.open(data.url, '_system');

                  let winTick = setInterval(() => {
                    if (win && win.closed) {
                      clearInterval(winTick);
                      this.getBill(data.id, 'billplz');
                    }
                  }, 500);

                  // var browserRef = window.open(data.url,"_blank","hidden=no,location=no,clearsessioncache=yes,clearcache=yes,hardwareback=no");
                  // browserRef.addEventListener('loadstop', function(e: InAppBrowserEvent) {
                  // var loc = e.url;
                  // if(loc == "http://tax.lsgkerala.gov.in/epayment/paymentreturn.php")
                  // {
                  //         setTimeout(function () {
                  //         browserRef.close();
                  //         }, 5000);
                  // }
                  // });
                }
              } else if (data && this.selectPaymentMethod.toLowerCase().includes('ipay88')) {
                // this.selectPaymentMethod === 'ipay88page' || this.selectPaymentMethod === 'ipay88fpx'

                let _data = data;
                let _type = _paymentGateway;

                let _amountPay;
                let _amount;
                if (paymentDetails && paymentDetails.amount) _amountPay = paymentDetails.amount;
                // if(paymentDetails && paymentDetails.amount) _amount = paymentDetails.amount;
                //  = (_pgRegion.toLowerCase().includes('ipay88-id'))?_amountPay*100:1.00;
                if (
                  _pgRegion.toLowerCase().includes('ipay88-id') &&
                  _countryId.toLowerCase() === 'idn' &&
                  _pgDescription.toLowerCase('sandbox')
                )
                  _amountPay = 10000;
                else if (
                  _pgRegion.toLowerCase().includes('ipay88-id') &&
                  _countryId.toLowerCase() === 'idn' &&
                  _pgDescription.toLowerCase('sandbox')
                )
                  _amount = _amountPay * 100;
                // else if(!_pgRegion.toLowerCase().includes('ipay88-id') && this.pgDescription.toLowerCase().includes('Sandbox'.toLowerCase())) _amount = 1*100;
                else if (
                  _type.toLowerCase().includes('ipay88') &&
                  _countryId.toLowerCase() === 'mys' &&
                  !this.pgDescription.toLowerCase().includes('Sandbox'.toLowerCase())
                )
                  _amount = _amountPay.toFixed(2);
                else if (
                  _type.toLowerCase().includes('ipay88') &&
                  _countryId.toLowerCase() === 'mys' &&
                  this.pgDescription.toLowerCase().includes('Sandbox'.toLowerCase())
                )
                  _amount = 100;
                else _amount = _amountPay * 100;

                let _ipayUrl;
                if (this.selectPaymentMethod === 'ipay88fpx')
                  _ipayUrl = 'https://dvl3.ipay88.com/epayment/entry.asp';
                else {
                  if (_pgRegion.toLowerCase().includes('ipay88-id'))
                    // _pgRegion === 'ipay88-id'
                    _ipayUrl = this.paymentPageURL; //'https://sandbox.ipay88.co.id/epayment/entry.asp';
                  else _ipayUrl = 'https://payment.ipay88.com.my/epayment/entry.asp';
                }
                // https://dvl3.ipay88.com/epayment/entry.asp
                this.localBill = _data.bill;

                let paymentDetailsPage;
                let _currency = this.selectedDiscountCompany.country.currencyCode;
                if (0 && this.selectPaymentMethod === 'ipay88fpx') {
                  // _signature = 'YaYNkBlUnq' + 'M15668' + _data.bill + _amount*100 + _currency;
                  // let _userEmail;
                  // let _userName;
                  // let _userContact;
                  // let sha256_signature = sha256(_signature);
                  // paymentDetailsPage = {
                  //         "MerchantCode": 'M15668',
                  //         "PaymentId": '',
                  //         "RefNo": _data.bill, //'TestPay88_'+moment().format('HHmmss'),
                  //         "Amount": _amount,
                  //         "Currency": _currency,
                  //         "ProdDesc": 'NGA Application',
                  //         "UserEmail": _userEmail,
                  //         "UserName": _userName,
                  //         "UserContact": _userContact,
                  //         // "UserName": this.bookingSlot.bookedByPlayer?this.bookingSlot.bookedByPlayer.playerName:this.bookingSlot.bookingPlayers[0].playerName ,
                  //         // "UserEmail": this.bookingSlot.bookedByPlayer?this.bookingSlot.bookedByPlayer.email:this.bookingSlot.bookingPlayers[0].email,
                  //         // "UserContact": this.bookingSlot.bookedByPlayer?(this.bookingSlot.bookedByPlayer.address.phone1 ? this.bookingSlot.bookedByPlayer.address.phone1: this.bookingSlot.bookedByPlayer.address.phone2):this.bookingSlot.bookingPlayers[0].phone, //this.bookingSlot., no phone in bookedbyplayer!
                  //         // "UserName": this.bookingSlot.bookedByPlayer.playerName,
                  //         // "UserEmail": this.bookingSlot.bookedByPlayer.email,
                  //         // "UserContact": this.bookingSlot.bookedByPlayer.address.phone1 ? this.bookingSlot.bookedByPlayer.address.phone1 : this.bookingSlot.bookedByPlayer.address.phone2, //this.bookingSlot., no phone in bookedbyplayer!
                  //         "Remark": 'NGA Application',
                  //         "SignatureType": 'SHA256',
                  //         "Signature": sha256_signature,
                  //         "ResponseURL": this.paymentRedirectURL,
                  //         // "ResponseURL": 'http://azu-play.mygolf2u.com/payment_redirect.html',
                  //         // "BackendURL": 'http://azulet.mygolf2u.com/rest/payment/ipay88/backend',
                  //         // "BackendURL": 'http://devlet.mygolf2u.com/rest/payment/ipay88/backend',
                  //         "BackendURL": this.paymentBackendURL,
                  //         // _data.callback_url?_data.callback_url:this.paymentBackendURL,//'http://devlet.mygolf2u.com/rest/payment/ipay88/backend'
                  // }
                } else {
                  // _signature = 'huqhrKBj1i' + 'M27515' + _data.bill + _amount + this.bookingSlot.slotAssigned.currency.id;
                  if (
                    _pgRegion.toLowerCase().includes('ipay88-id') &&
                    this.pgDescription.toLowerCase().includes('sandbox')
                  )
                    _signature =
                      this.ipay88Details.merchantKey +
                      this.ipay88Details.merchantCode +
                      _data.bill +
                      Number(_amount).toFixed(0) +
                      _currency;
                  else if (
                    _pgRegion.toLowerCase().includes('ipay88-id') &&
                    !this.pgDescription.toLowerCase().includes('sandbox')
                  )
                    _signature =
                      this.ipay88Details.merchantKey +
                      this.ipay88Details.merchantCode +
                      _data.bill +
                      Number(_amountPay).toFixed(0) +
                      _currency;
                  else if (
                    _pgRegion.toLowerCase() === 'ipay88' &&
                    this.pgDescription.toLowerCase().includes('sandbox')
                  )
                    _signature =
                      this.ipay88Details.merchantKey +
                      this.ipay88Details.merchantCode +
                      _data.bill +
                      Number(100).toFixed(0) +
                      _currency;
                  else if (
                    _pgRegion.toLowerCase().includes('ipay88-my') &&
                    this.pgDescription.toLowerCase().includes('sandbox')
                  )
                    _signature =
                      this.ipay88Details.merchantKey +
                      this.ipay88Details.merchantCode +
                      _data.bill +
                      Number(1).toFixed(0) +
                      _currency;
                  else
                    _signature =
                      this.ipay88Details.merchantKey +
                      this.ipay88Details.merchantCode +
                      _data.bill +
                      Number(_amountPay).toFixed(0) +
                      _currency;
                  // *100

                  // _signature = 'huqhrKBj1i'+'M27515'+'TestPay88_'+moment().format('HHmmss')+'1'+this.bookingSlot.slotAssigned.currency.id;

                  let sha256_signature = this.mg2uUtil.generateHashSignature(
                    this.paymentSignAlgo,
                    _signature,
                    this.ipay88Details.merchantKey
                  ); //sha256(_signature);
                  let sha1_signature = this.mg2uUtil.generateHashSignature(
                    'sha1',
                    _signature,
                    this.ipay88Details.merchantKey
                  ); //; //!this.sha1.iPay88Signature(_signature);
                  let ipay88_signature;
                  // if(data && data.signature) ipay88_signature = (_pgRegion.toLowerCase().includes('ipay88-id'))?data.signature:sha256_signature; //data.signature;
                  // else ipay88_signature = (_pgRegion.toLowerCase().includes('ipay88-id'))?sha1_signature:sha256_signature;
                  ipay88_signature = _pgRegion.toLowerCase().includes('ipay88-id')
                    ? sha1_signature
                    : sha256_signature;
                  // ipay88_signature = (_pgRegion==='ipay88-id')?sha1_signature:sha256_signature

                  let _userEmail = this.player.email;
                  let _userName = this.player.playerName;
                  let _userContact = this.player.phone;

                  let _finalAmount = this.sandboxPayment ? 1 : (_amountPay / 100).toFixed(2);
                  paymentDetailsPage = {
                    MerchantCode: this.ipay88Details.merchantCode,
                    PaymentId: '',
                    RefNo: _data.bill, //'TestPay88_'+moment().format('HHmmss'),
                    Amount: _finalAmount,
                    Currency: _currency,
                    ProdDesc: 'NHS Handicap Application',
                    UserEmail: _userEmail,
                    UserName: _userName,
                    UserContact: _userContact,
                    // "UserName": this.bookingSlot.bookedByPlayer?this.bookingSlot.bookedByPlayer.playerName:this.bookingSlot.bookingPlayers[0].playerName ,
                    // "UserEmail": this.bookingSlot.bookedByPlayer?this.bookingSlot.bookedByPlayer.email:this.bookingSlot.bookingPlayers[0].email,
                    // "UserContact": this.bookingSlot.bookedByPlayer?(this.bookingSlot.bookedByPlayer.address.phone1 ? this.bookingSlot.bookedByPlayer.address.phone1: this.bookingSlot.bookedByPlayer.address.phone2):this.bookingSlot.bookingPlayers[0].phone, //this.bookingSlot., no phone in bookedbyplayer!
                    Remark: 'Payment for NHS Subscription',
                    SignatureType: this.paymentSignAlgo,
                    // _pgRegion==='ipay88-id'?'SHA1':'SHA256',
                    Signature: ipay88_signature, // _data.signature ? _data.signature : ipay88_signature,
                    ResponseURL: this.paymentRedirectURL,
                    // "ResponseURL": 'http://azu-play.mygolf2u.com/payment_redirect.html',
                    // "BackendURL": 'http://azulet.mygolf2u.com/rest/payment/ipay88/backend',
                    // "BackendURL": 'http://devlet.mygolf2u.com/rest/payment/ipay88/backend',
                    BackendURL: this.paymentBackendURL,
                    PaymentURL: this.paymentPageURL,
                    // "https://payment.ipay88.co.id/epayment/entry.asp"
                    // _data.callback_url?_data.callback_url:this.paymentBackendURL,//'http://devlet.mygolf2u.com/rest/payment/ipay88/backend'
                  };
                  console.debug(
                    'preparing ipay88',
                    paymentDetailsPage,
                    _data,
                    _data.signature,
                    ipay88_signature
                  );
                }

                // let _merchantCode = paymentDetailsPage['MerchantCode'];
                let _MerchantCode = paymentDetailsPage['MerchantCode'];
                let _PaymentId = paymentDetailsPage['PaymentId'];
                let _RefNo = _data.bill; //paymentDetailsPage["RefNo"]
                let _Amount = paymentDetailsPage['Amount'];
                let _Currency = paymentDetailsPage['Currency'];
                let _ProdDesc = paymentDetailsPage['ProdDesc'];
                let _UserName = paymentDetailsPage['UserName'];
                let _UserEmail = paymentDetailsPage['UserEmail'];
                let _UserContact = paymentDetailsPage['UserContact'];
                let _Remark = paymentDetailsPage['Remark'];
                let _SignatureType = paymentDetailsPage['SignatureType'];
                let _Signature = paymentDetailsPage['Signature'];
                let _ResponseURL = paymentDetailsPage['ResponseURL'];
                let _BackendURL = paymentDetailsPage['BackendURL'];

                let _params =
                  'MerchantCode=' +
                  _MerchantCode +
                  '&PaymentId=' +
                  _PaymentId +
                  '&RefNo=' +
                  _RefNo +
                  '&Amount=' +
                  _Amount +
                  '&Currency=' +
                  _Currency +
                  '&ProdDesc=' +
                  _ProdDesc +
                  '&UserName=' +
                  _UserName +
                  '&UserEmail=' +
                  _UserEmail +
                  '&UserContact=' +
                  _UserContact +
                  '&Remark=' +
                  _Remark +
                  '&SignatureType=' +
                  _SignatureType +
                  '&Signature=' +
                  _Signature +
                  '&ResponseURL=' +
                  _ResponseURL +
                  '&BackendURL=' +
                  _BackendURL;
                // _ipayUrl = '/ipay88page'

                let map;

                var form = document.createElement('form');
                form.target = '_system';
                form.method = 'GET';
                form.action = this._url;
                form.style.display = 'none';

                for (var key in paymentDetailsPage) {
                  var input = document.createElement('input');
                  input.type = 'hidden';
                  input.name = key;
                  input.value = paymentDetailsPage[key];
                  form.appendChild(input);
                }

                let _ipay88Header = `<html>
                            <head>
                            </head>`;

                // http://app.mygolf2u.com/payment/goToPayment.html
                let _ipay88Body =
                  `<body >
    <form id="loginForm" action="` +
                  this.paymentInternalURL +
                  `" method="get">
        <span style="font-size:5vw;">Redirecting to payment page ...</span><br>`;

                for (var key in paymentDetailsPage) {
                  _ipay88Body +=
                    '<input type="hidden" name="' +
                    key +
                    '" value="' +
                    paymentDetailsPage[key] +
                    '">';
                }

                let _ipay88end = `<script type="text/javascript">
        setTimeout("document.getElementById('loginForm').submit()", 500);
        </script>
    </body>

    </html>`;

                let _ipay88content = _ipay88Header + _ipay88Body + _ipay88end;

                // let _ipay88ContentUrl = 'data:text/html;base64,' +this.mg2uUtil._btoa(encodeURIComponent(_ipay88content)); //btoa(_ipay88content);
                let _ipay88ContentUrl =
                  'data:text/html;base64,' + this.mg2uUtil._btoa(_ipay88content);

                let win;
                if (this.platform.is('capacitor')) {
                  this.openWithInAppBrowser(_ipay88ContentUrl, null, 'getBill', data);
                } else {
                  win = window.open('', '_system');
                  document.body.appendChild(form);
                  form.submit();
                  document.body.removeChild(form);
                }

                let winTick = setInterval(() => {
                  if (win && win.closed) {
                    clearInterval(winTick);
                    this.getBill(data.bill, 'ipay88');
                    //
                  }
                }, 500);
              }
            },
            error => {
              if (error) {
                let _error = error;
                if (_error.status === '500' || _error.status === '404') {
                  MessageDisplayUtil.showMessageToast(
                    'Server Unreachable',
                    this.platform,
                    this.toastCtl,
                    3000,
                    'bottom'
                  );
                } else if (_error.status === 500 || _error.status === 404) {
                  MessageDisplayUtil.showMessageToast(
                    'Server Unreachable',
                    this.platform,
                    this.toastCtl,
                    3000,
                    'bottom'
                  );
                }
              }
            }
          );
        },
        error => {
          if (loader) loader.dismiss();
          let _msg = error;
          if (_msg.toLowerCase().includes('mobile is invalid')) {
            _msg = 'Mobile phone is invalid. Please update profile and retry payment.';
            // if(!this.fromClub) {

            //     let alert = this.alertCtl.create({
            //         title: 'Insufficient Player Info',
            //         // subTitle: 'Selected date is '+ _date,
            //         message: 'This Payment Gateway needs a valid phone number to proceed. Do you want to update profile?', //'Selected date is ' + '<b>' + _date + '</b>',
            //         // buttons: ['Close']
            //         buttons: [{
            //             text: 'No'
            //         },{
            //             text: 'Update',
            //             handler: () => {

            //                     let modal = this.modalCtrl.create(EditProfilePage, {
            //                     homeInfo: this.playerHomeInfo$,
            //                     player  : this.player$,
            //                     type    : 'playerProfile'
            //                     });

            //                     modal.onDidDismiss((data?: any) => {
            //                         // this.refreshProfile();
            //                         // this.refreshPlayerInfo();
            //                         // this.refreshBookingDetails()

            //                     });
            //                     modal.present();
            //                     }

            //         }]
            //     });
            //     alert.present();
            // }
            // return false;
          } else {
            _msg = 'Something wrong going with payment server. Please try again.';
          }
          MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
          // return false;
        }
      );
    });
    setTimeout(async () => {
      loader.dismiss().then(() => {});
    }, 300000);
  }

  public openWithSystemBrowser(url: string) {
    let target = '_system';
    this.iab.create(url, target, this.options);
  }
  public openWithInAppBrowser(url: string, target?: string, attribute?: string, data?: any) {
    let _target;
    if (target) _target = target;
    else _target = '_blank';
    if (this.platform.is('ios')) _target = '_blank';
    let _iab = this.iab.create(url, _target, this.options);

    if (this.platform.is('ios')) {
      _iab.on('loadstart').subscribe(event => {
        let loc = event.url.toLowerCase();
        if (loc.includes(this.paymentRedirectURL.toLowerCase())) {
          setTimeout(function () {
            _iab.close();
          }, 5000);
        }
      });
    } else {
      _iab.on('loadstop').subscribe(event => {
        let loc = event.url.toLowerCase();
        if (loc.includes(this.paymentRedirectURL)) {
          setTimeout(function () {
            _iab.close();
          }, 5000);
        }
      });
    }
    // _iab.on('')
    // _iab.on('loadstop').subscribe(event => {

    //     MessageDisplayUtil.showMessageToast('IAB stop',
    //         this.platform, this.toastCtl, 10000, "bottom")
    //  });

    // MessageDisplayUtil.showMessageToast('IAB loading...',
    // this.platform, this.toastCtl,10000, "bottom");
    _iab.on('exit').subscribe(
      () => {
        // MessageDisplayUtil.showMessageToast('exit IAB - '+data.bill + '|'+this.selectPaymentMethod,
        // this.platform, this.toastCtl,10000, "bottom");
        if (attribute === 'getBill') {
          if (this.selectPaymentMethod.toLowerCase().includes('billplz')) {
            this.getBill(data.id, 'billplz');
          } else if (this.selectPaymentMethod.toLowerCase().includes('ipay88'))
            this.getBill(data.bill, 'ipay88');
        }
      },
      err => {}
    );
  }
  public openWithCordovaBrowser(url: string) {
    let target = '_system';
    this.iab.create(url, target, this.options);
  }

  paymentMode: boolean = false;
  paymentStatus: string = '';
  public async getBill(billId?: string, paymentGateway?: string) {
    //
    let loader = this.loadingCtl.create({
      showBackdrop: false,
      cssClass: 'nobg',
      message: 'Getting bill info...',
      duration: 10000,
    });
    (await loader).present().then(async () => {
      this.paymentService.getBill(billId, paymentGateway).subscribe(
        async (data: any) => {
          if (
            (data?.status && data?.paid === 'true' && data?.status.toLowerCase() === 'p') ||
            (data?.state && data?.state.toLowerCase() === 'paid' && paymentGateway === 'billplz')
          ) {
            //   this.toggleRegister = true;

            this.paymentMode = false;
            this.paymentStatus = 'Paid';
            // let alert = this.alertCtl.create({
            //   header: 'Payment successful',
            //   // subTitle: 'Selected date is '+ _date,
            //   message: 'Thank you for the payment.<br>Receipt will be sent to you via email.', //'Selected date is ' + '<b>' + _date + '</b>',
            //   // buttons: ['Close']
            //   buttons: [{
            //     text: 'Close',
            //     handler: () => {

            //       // this.nav.pop()
            //       this.modalCtrl.dismiss({
            //         needRefresh: true
            //       })
            //       //   this.recalculateBookingPricing();
            //       //   this.paymentAmountType = 'full';

            //     }
            //   }],
            //   // enableBackdropDismiss: false,
            //   backdropDismiss: false
            // });
            // (await loader).dismiss().then(async () => {
            //   (await alert).present();
            // })

            this.showMessage(
              'Payment successful',
              'Thank you for the payment.<br>Receipt will be sent to you via email.'
            ).then((result: any) => {
              if (result) {
                this.modalCtrl.dismiss({
                  needRefresh: true,
                });
              }
            });

            //   this.paymentFailed = false;
            //   this.paymentDateTime = null;
          } else if (
            (data?.status && data?.status.toLowerCase() === 'p') ||
            (data?.state && data?.state.toLowerCase() === '1' && paymentGateway === 'ipay88')
          ) {
            // let alert = this.alertCtl.create({
            //   header: 'Payment successful',
            //   // subTitle: 'Selected date is '+ _date,
            //   message: 'Thank you for the payment.<br>Receipt will be sent to you via email.', //'Selected date is ' + '<b>' + _date + '</b>',
            //   // buttons: ['Close']
            //   buttons: [{
            //     text: 'Close',
            //     handler: () => {
            //       this.modalCtrl.dismiss({
            //         needRefresh: true
            //       })

            //       //   this.recalculateBookingPricing();
            //       //   this.paymentAmountType = 'full';

            //     }
            //   }],
            //   // enableBackdropDismiss: false,
            //   backdropDismiss: false

            // });
            // (await loader).dismiss().then(async () => {
            //   (await alert).present();
            // })

            this.showMessage(
              'Payment successful',
              'Thank you for the payment.<br>Receipt will be sent to you via email.'
            ).then((result: any) => {
              if (result) {
                this.modalCtrl.dismiss({
                  needRefresh: true,
                  paymentDateTime: this.paymentDateTime,
                  paymentStatus: 'failed',
                });
              }
            });
          } else if (
            (data?.state && data?.state.toLowerCase() === 'due') ||
            (data?.status && data?.status.toLowerCase() === 'd')
          ) {
            //   this.paymentStatus = 'Due';

            // let alert = this.alertCtl.create({
            //   header: 'Payment not successful',
            //   cssClass: 'booking-error',
            //   // subTitle: 'Selected date is '+ _date,
            //   message: 'Something went wrong with payment. Please refresh and try again in few minutes.', //'Selected date is ' + '<b>' + _date + '</b>',
            //   // buttons: ['Close']
            //   buttons: [{
            //     text: 'Close',
            //     handler: () => {
            //       //! this.viewCtrl.dismiss({
            //       //!     needRefresh: true
            //       //! })
            //       //   this.recalculateBookingPricing();
            //     }
            //   }],
            //   // enableBackdropDismiss: false,
            //   backdropDismiss: false

            // });
            // (await loader).dismiss().then(async () => {
            //   (await alert).present();
            // })

            this.showMessage(
              'Payment not successful',
              'Something went wrong with payment. Please refresh and try again in few minutes.',
              true
            ).then((result: any) => {
              if (result) {
                this.modalCtrl.dismiss({
                  needRefresh: true,
                  paymentDateTime: this.paymentDateTime,
                  paymentStatus: 'failed',
                });
              }
            });

            if (this.enablePaymentTimer) {
              this.paymentFailed = true;
              this.paymentDateTime = moment();
            }
          } else {
            if (0) {
              // this.enablePaymentTimer
              //   this.paymentFailed = true;
              //   this.paymentDateTime = moment();
            }
            this.modalCtrl.dismiss({
              needRefresh: true,
            });
            //   this.onCancelAssignment()
          }
        },
        async error => {
          this.paymentStatus = 'Pending';

          // let alert = this.alertCtl.create({
          //   header: 'Ooops',
          //   cssClass: 'booking-error',
          //   // subTitle: 'Selected date is '+ _date,
          //   message: 'Something went wrong with payment. Please refresh and try again in few minutes.', //'Selected date is ' + '<b>' + _date + '</b>',
          //   // buttons: ['Close']
          //   buttons: [{
          //     text: 'Close',
          //     handler: () => {
          //       if (this.enablePaymentTimer) {
          //         this.paymentFailed = true;
          //         this.paymentDateTime = moment();
          //       }
          //       //! this.viewCtrl.dismiss({
          //       //!     needRefresh: true
          //       //! })
          //       //   this.recalculateBookingPricing();
          //     }
          //   }],
          //   // enableBackdropDismiss: false,
          //   backdropDismiss: false

          // });
          // (await loader).dismiss().then(async () => {
          //   (await alert).present();
          // })

          this.showMessage(
            'Ooops',
            'Something went wrong with payment. Please refresh and try again in few minutes.',
            true
          ).then((result: any) => {
            if (result) {
              if (this.enablePaymentTimer) {
                this.paymentFailed = true;
                this.paymentDateTime = moment();
              }
            }
          });
        }
      );
      if (loader) (await loader).dismiss();
    });
  }

  onCancel() {
    this.modalCtrl.dismiss();
  }

  getNewValidity(currentDate: boolean, date?: any, attribute?: string) {
    if (!this.selectedDiscountProgram) return;
    if (this.selectedDiscountProgram === '') return;
    if (!this.discountPrograms) return;
    let _selDiscountProgram: DiscountCompanyProgram;
    if (this.discountPrograms && this.discountPrograms.length > 0) {
      this.discountPrograms
        .filter((dp: DiscountCompanyProgram) => {
          return dp.id === this.selectedDiscountProgram;
        })
        .map(dp => {
          _selDiscountProgram = dp;
        });
    }

    let _newDate = '';
    if (!currentDate)
      _newDate = moment(date, 'YYYY-MM-DD')
        .add(_selDiscountProgram.validityMonths, 'months')
        .format('YYYY-MM-DD');
    else if (currentDate && attribute === 'start') _newDate = moment().format('ddd, DD MMM YYYY');
    else if (currentDate && attribute === 'end')
      _newDate = moment()
        .add(_selDiscountProgram.validityMonths, 'months')
        .format('ddd, DD MMM YYYY');
    return _newDate;
  }

  onApplicationValid() {
    if (!this.termsRulesAgreed) return false;
    if (!this.onCheckAddress()) return false;
    if (!this.inputApplication.fullName || this.inputApplication?.fullName?.trim().length <= 2)
      return false;
    if (!this.inputApplication.dateOfBirth) return false;
    if (
      !this.inputApplication.govtDocumentNumber ||
      this.inputApplication.govtDocumentNumber?.trim().length <= 3
    )
      return false;
    return true;
  }

  onCheckAddress() {
    // if(!this.getDiscountProgramDetails('isInsurance')) return true;
    if (!this.userAddressData) return false;
    if (this.userAddressData && this.userAddressData.length === 0) return false;
    if (this.userAddressData && this.userAddressData.length > 0) {
      if (this.defaultUserAddress) {
        if (!this.defaultUserAddress.address) return false;
        if (this.defaultUserAddress.address && !this.defaultUserAddress.address.address1)
          return false;
        if (this.defaultUserAddress.address && !this.defaultUserAddress.address.city) return false;
        if (this.defaultUserAddress.address && !this.defaultUserAddress.address.state) return false;
        if (this.defaultUserAddress.address && !this.defaultUserAddress.address.postCode)
          return false;
        return true;
      } else return false;
    } else return true;
  }

  onRefreshAddress() {
    // this.playerHomeActions.refreshForcefully();

    // if(this.player$)
    // this.player$.take(1).subscribe((player: PlayerInfo) => {
    //     this.player =  player
    // });

    let _userId = this.player.userId;
    this.flightService.getUserDetailsById(_userId).subscribe((data: UserAuthentication) => {
      if (data && data.userAddresses) {
        this.userAddressData = data.userAddresses;
        if (this.userAddressData)
          this.userAddressData
            .filter((uad: UserAddress, idx, arr) => {
              if (arr && arr.length === 1 && !uad.defaultAddress) return true;
              else return uad.defaultAddress;
            })
            .map(uad => {
              this.defaultUserAddress = uad;
              if (uad && uad.address && uad.address.phone1) this.player.phone = uad.address.phone1;
            });
      }

      // if(data && data)
    });
  }

  getPromoIsActive() {
    return new Promise((resolve, reject) => {
      this.flightService.getPromoIsActive('NHS_APPLICATION').subscribe(data => {
        if (data) {
          resolve(true);
        } else resolve(false);
      });
    });
  }

  couponCode: string;
  codeEntered: boolean = false;
  promoValid: boolean = false;
  getPromoCode() {
    let _context: string = 'NHS_APPLICATION';
    let _couponCode: string = this.couponCode;
    this.flightService.getPromoCode(_context, _couponCode).subscribe(data => {
      if (data && data.length > 0) {
        let _hasData = data.filter(pc => {
          return pc.promoCode === _couponCode && pc.partner;
        });
        setTimeout(() => {
          this.codeEntered = true;
          if (_hasData && _hasData.length > 0) {
            this.selectedDiscountProgram = null;
            this.selectedDiscountCompany = _hasData[0].partner;
            this.getDiscountPrograms(this.selectedDiscountCompany);
            this.promoValid = true;
          } else {
            this.promoValid = false;
          }
        }, 1000);
      } else {
        this.codeEntered = true;
        this.promoValid = false;
      }
    });
  }
  clearPromoCode() {
    this.selectedDiscountCompany = null;
    this.selectedDiscountProgram = null;
    this.promoValid = false;
    this.couponCode = '';
    this.codeEntered = false;
  }

  async optionMenu() {
    const modal = await this.modalCtrl.create({
      component: OptionsMenuComponent,
      mode: 'ios',
      backdropDismiss: false,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        headerTitle: 'Options',
        modeFrom: 'handiCap',
      },
    });
    modal.present();
    await modal.onDidDismiss().then(data => {
      if (data?.data) {
        switch (data?.data) {
          case 'manageAddress':
            this.goEditAddressPage();
            break;
          case 'editProfile':
            this.goEditProfilePage();
            break;
        }
      }
    });
  }

  selectProgramAccount: any;
  getProgramName() {
    let _selectedProgram = 'Select Program';
    if (!this.discountPrograms) return _selectedProgram;
    if (!this.selectedDiscountProgram) return _selectedProgram;
    _selectedProgram = this.discountPrograms.find(program => {
      return program.id === this.selectedDiscountProgram;
    })?.name;
    return _selectedProgram;
    // return this.selectProgramAccount && this.selectProgramAccount.name ? this.selectProgramAccount.name : 'Select Program';
  }

  async selectProgram() {
    const modal = await this.modalCtrl.create({
      component: OptionsMenuComponent,
      mode: 'ios',
      backdropDismiss: false,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        headerTitle: 'Select Program',
        modeFrom: 'program',
        selectProgramAccount: this.selectProgramAccount,
        discountPrograms: this.discountPrograms,
      },
    });
    modal.present();
    await modal.onDidDismiss().then(data => {
      if (data?.data) {
        this.selectedDiscountProgram = data?.data?.id;
        this.selectProgramAccount = data?.data;
        this.getProgramName();
      }
    });
  }

  parseDate(date: any, format?: string, oriFormat?: string) {
    if (!date) return;
    if (format) {
      if (oriFormat) return moment(date, oriFormat).format(format);
      else return moment(date).format(format);
    } else {
      if (oriFormat) return moment(date, oriFormat).format('ddd, DD MMM YYYY');
      else return moment(date).format('ddd, DD MMM YYYY');
    }
  }

  showMessage(title: string, content: string, isError?: boolean) {
    return new Promise(async (resolve, reject) => {
      let _message = {
        title: title,
        content: content,
      };
      const modal = await this.modalCtrl.create({
        mode: 'ios',
        component: CommonPullupMenuComponent,
        cssClass: 'self-adjustable-modal',
        componentProps: {
          app: null,
          message: _message,
          mode: 'messageSuccess',
          // headerTitle: title,
        },
      });
      await modal.present().then(() => {
        const height = this.platform.height() - 250;
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
      });
      modal.onDidDismiss().then((data: any) => {
        console.debug('pullup dismiss', data);
        if (data) {
          resolve(true);
          // if(data?.data?.id) {
          //   // this._changeScorer(player, data?.data?.data);
          // }
        } else resolve(false);
        // if(data)
      });
    });
  }
}
